(()=>{
  const section=document.querySelector('[data-original-discovery]');
  if(!section)return;
  const config=JSON.parse(section.querySelector('[data-discovery-catalog]').textContent);
  const catalog=new Map(config.products.map(p=>[String(p.id),p]));
  const money=n=>new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(n/100);
  let scheduled=false,prefilled=false;
  function decorate(){
    scheduled=false;prefill();
    const family=section.querySelector('[data-discovery-family]').value.toLowerCase();
    for(const card of section.querySelectorAll('[data-bw-product-card]')){
      const id=(card.dataset.currentSelectedVariantId||card.dataset.productId||'').split('/').pop();
      const p=catalog.get(id);if(!p)continue;
      const image=card.querySelector('.bw-product-card__image');
      if(image&&image.getAttribute('src')!==p.image){image.src=p.image;image.removeAttribute('srcset');image.alt=p.title+' · '+config.labels.size;}
      const body=card.querySelector('.bw-product-card__text');
      if(body&&!body.querySelector('.ks-discovery-inspiration')){
        const copy=document.createElement('p');copy.className='ks-discovery-inspiration';
        if(p.inspired){copy.append(document.createTextNode(config.labels.inspired+' '));const strong=document.createElement('strong');strong.textContent=p.inspired;copy.append(strong);}
        body.append(copy);
        const size=document.createElement('small');size.className='ks-discovery-size';size.textContent=config.labels.size;body.append(size);
        if(p.reference>0&&p.referenceSize){const reference=document.createElement('small');reference.className='ks-discovery-reference';reference.textContent=config.labels.reference+' '+money(p.reference)+' · '+p.referenceSize;body.append(reference);}

      }
      card.hidden=!!family&&!String(p.family).toLowerCase().includes(family);
    }
    for(const panel of section.querySelectorAll('[data-discovery-mode]')){

      const side=panel.querySelector('.full-page-side-panel');if(!side)continue;
      let text=side.querySelector('.ks-discovery-selection');
      if(!text){text=document.createElement('p');text.className='ks-discovery-selection';side.append(text);}
      const selected=[...panel.querySelectorAll('[data-bw-product-card]')].filter(c=>c.getAttribute('aria-label')?.endsWith('(selected)')).map(c=>c.querySelector('.bw-product-card__title')?.textContent.trim()).filter(Boolean);
      const copy=selected.length?selected.join(' · '):config.labels.empty;
      if(text.textContent!==copy)text.textContent=copy;
    }
  }
  async function prefill(){
    if(prefilled||!section.querySelector('[data-bw-product-card]'))return;
    prefilled=true;
    const handles=(new URL(location.href).searchParams.get('scents')||'').split(',').filter(Boolean).slice(0,6);
    for(const handle of handles){
      const product=config.products.find(p=>p.url.split('/').pop()===handle);if(!product)continue;
      const card=[...section.querySelectorAll('[data-bw-product-card]')].find(c=>(c.dataset.currentSelectedVariantId||c.dataset.productId||'').endsWith('/'+product.id));
      const button=card?.querySelector('.bw-product-card__add-button,.product-quantity-btn:last-child');
      if(button&&!button.disabled)button.click();
      await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
    }
  }
  function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(decorate);}}
  section.addEventListener('change',e=>{
    if(e.target.name==='discovery_delivery'){
      const url=new URL(location.href);
      url.searchParams.set('view',e.target.value==='subscription'?'discovery-subscription':'mix-and-match');
      const picks=[];
      for(const card of section.querySelectorAll('[data-bw-product-card]')){
        if(!card.getAttribute('aria-label')?.endsWith('(selected)'))continue;
        const product=catalog.get((card.dataset.currentSelectedVariantId||card.dataset.productId||'').split('/').pop());
        const quantity=Number(card.querySelector('.bw-product-card__action')?.textContent.match(/\d+/)?.[0]||1);
        if(product)for(let i=0;i<quantity;i++)picks.push(product.url.split('/').pop());
      }
      if(picks.length)url.searchParams.set('scents',picks.slice(0,6).join(','));else url.searchParams.delete('scents');
      url.hash='DiscoveryBuilder';location.assign(url.href);
    }
    if(e.target.matches('[data-discovery-family]'))schedule();
  });
  new MutationObserver(schedule).observe(section,{childList:true,subtree:true,attributes:true,attributeFilter:['src','aria-label']});
  decorate();
})();

